import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MailForwardingComponent } from './mail-forwarding.component';
import { LocationsModule } from '../../shared/locations/locations.module';
import { WsgSharedModule } from '@morningstar/wsg/shared';
import { AddressPipeModule } from '../../shared/pipes/address/address-pipe.module';

@NgModule({
  declarations: [
    MailForwardingComponent
  ],
  imports: [
    CommonModule,
    WsgSharedModule,
    LocationsModule,
    AddressPipeModule
  ]
})
export class MailForwardingModule { }
